// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2aoY-","title":"BackImages_title__wbkOR","images":"BackImages_images__3vFUk"};